import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import { useState, useEffect } from 'react';
import Modal from '../../helpers/Modal';
const TAG_FIELDS = [
    { key: 'is_quoted', label: 'Quoted' },
    { key: 'pe_stamps_ordered', label: 'PE Stamps Ordered' },
    { key: 'op_package_ordered', label: 'Optimization Package Ordered' },
];

export const ManageDesignTagsForm = ({ design, setDesigns }) => {
    const { token, base_url } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tags, setTags] = useState({
        is_quoted: false,
        pe_stamps_ordered: false,
        op_package_ordered: false,
    });

    useEffect(() => {
        if (isModalOpen) {
            setTags({
                is_quoted: Boolean(design.is_quoted),
                pe_stamps_ordered: Boolean(design.pe_stamps_ordered),
                op_package_ordered: Boolean(design.op_package_ordered),
            });
        }
    }, [isModalOpen, design]);

    const handleTagChange = (key) => {
        setTags((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            const updated_design = await updateData(
                token,
                `${base_url}/apis/designs/${design.id}`,
                tags
            );

            if (updated_design.design) {
                setDesigns((prevDesigns) =>
                    prevDesigns.map((d) =>
                        d.id === design.id ? updated_design.design : d
                    )
                );

                window.showAlert(200, 'Design tags updated successfully!');
                setIsModalOpen(false);
            }
        } catch (error) {
            console.error('Error updating design tags:', error);

            if (error.status === 404) {
                window.showAlert(404, 'Design not found');
            } else if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, 'Invalid design data. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to update design tags. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const manageDesignTagsForm = (
        <form onSubmit={handleSubmit}>
            <h2>Manage Design Tags</h2>
            <p><strong>Design: {design?.design_name || design?.unique_id}</strong></p>
            <p>Toggle quote and order tags for this design.</p>

            <div className="form-group">
                {TAG_FIELDS.map(({ key, label }) => (
                    <label key={key} className="checkbox-label checkbox-label--block">
                        <input
                            type="checkbox"
                            checked={tags[key]}
                            onChange={() => handleTagChange(key)}
                        />
                        {label}
                    </label>
                ))}
            </div>

            <div className="form-actions">
                <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="btn btn-secondary"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <FontAwesomeIcon icon={faSpinner} spin /> Saving...
                        </>
                    ) : (
                        'Save Tags'
                    )}
                </button>
            </div>
        </form>
    );

    return (
        <>
            <button
                onClick={() => setIsModalOpen(true)}
                className="btn btn-action btn-secondary"
                title="Manage Design Tags"
            >
                <FontAwesomeIcon icon={faTags} />
                <span className="dropdown-item-label">Manage Design Tags</span>
            </button>
            {isModalOpen && (
                <Modal form={manageDesignTagsForm} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
